import React, { useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, CardMedia, Collapse, Grid, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import avatar from '../../../../images/avatar-anonyme.png';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { deleteCompetition } from '../../../../actions/competitions.js';
import { confirmActionNotification } from '../../../../actions/notifications.js';
import { useNotifications } from '../../../../v2/notifications/NotificationManager.js';
import { Can } from '../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark, faFileExport, faImage, faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { ExportButton } from '../../../components/Dialog/ExportButton.js';

const CompetitionCard = ({ competition, removeCompetitionFromList, className="", showExport=true, showPicture=true }) => {
  // const [expanded, setExpanded] = useState(false);
  const [expandedCompetitionInfo, setExpandedCompetitionInfo] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {addNotification} = useNotifications()

  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };

  
  const handleExpandClick = (type) => {
    if (type==='competition-info'){
      setExpandedCompetitionInfo(!expandedCompetitionInfo);
    }
    
  };

  const handleEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres
    navigate(`/sports/competitions/create/${competition._id}`, { state: { from: currentURL } });
  };

  const handleMultiEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres
    navigate(`/sports/competitions/thirdparty/${competition.thirdPartyId}/${competition.thirdPartyEntityId}`, { state: { from: currentURL } });
  };

  
  const rawURL = `dsas-view/competition/${competition.name}_${competition._id}`;

  return (
    <Card className={className}>

      {/*SECTION HEADER*/}
      <Box className='padding-wrapper cardHeader'>
      <Typography className='cardTitle'>
        {competition.name}
        </Typography>
      </Box> 
      <Box className='large-separator'></Box>

      {/*SECTION PHOTO + EXPORT*/}
      <Box className='padding-wrapper'>
        <Grid container spacing={1.5}>
        {showPicture && <Grid item xs={showExport ? 6 : 12} sm={showExport ? 6 : 12} md={showExport ? 6 : 12} className='userAvatarWrapper'>
          {/* Image*/}
          {competition?.photoUrl && <CardMedia
            className='userAvatar'
            component="img"
            image={competition.photoUrl}
            alt={`${competition.name}`}
          />}
          {!competition.photoUrl && 
          <Box className='userAvatar'>
            <FontAwesomeIcon icon={faImage} />
          </Box>
          }
          {/* </Box> */}
          </Grid>}
          {showExport &&
          <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_PROFILE}>
            <Grid item xs={showPicture ? 6 : 12} sm={showPicture ? 6 : 12} md={showPicture ? 6 : 12}>
            <Box sx={{
              display: 'grid', 
            }}>
              
              <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_EXPORT}>
                <ExportButton targetUrl={rawURL}/>
              </Can>

            </Box>
          </Grid>         
          </Can> 
          }
        </Grid>
      </Box>


      {/*Expandable - Infos competition*/}
            <CardContent sx={{ flex: '1 0 auto' }}>
                <Box className='expandableMenu'>
                  <Typography>Info compétition</Typography>
                    <IconButton
                      sx={{ marginLeft: 'auto' }}
                      onClick={() => handleExpandClick('competition-info')}
                      aria-expanded={expandedCompetitionInfo}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                </Box>
                <Box className='large-separator medium-padding'></Box>
              <Collapse in={expandedCompetitionInfo} timeout="auto" unmountOnExit className='expandableInfos'>
                  <CardContent>
                    <Typography paragraph>Nombre de journées: {competition.nbDays || 'Non spécifié'}</Typography>
                    <Typography paragraph>Nombre d'équipes en phase finale: {competition.nbTeamFinalPhase ||  'Non spécifié'}</Typography>
                    <Box 
                    
                    sx={{ display: 'flex', alignItems: 'left' }}
                    >
                    <FontAwesomeIcon
                        icon={competition.particularGoalAverage ? faCircleCheck : faCircleXmark }
                        style={{ color: competition.particularGoalAverage ? 'var(--color-blue-secondary)' : '#ccc', fontSize: 'larger' }}
                    />
                    <Typography sx={{ paddingLeft: '0.5rem' }}>Goalaverage particulier</Typography>
                    </Box>
                  </CardContent>
              </Collapse>
            </CardContent>


            {/* Card Actions */}
            <Box className='large-separator'></Box>
            <Box className='cardActions'>

              <Box className='centered-column-wrapper'>
                <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_EDIT}>
                  <DsasButton label='Éditer' icon={faPenToSquare} onClick={handleEditClick} variant = 'secondary' />
                </Can>
      
                {(competition.thirdPartyId && competition.thirdPartyEntityId) && 
                <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_MULTIEDIT}>
                  <DsasButton label='Multi-édition' icon={faPenToSquare} onClick={handleMultiEditClick} variant = 'secondary' />
                </Can>
                }
              </Box>
      
              <Box className='xl-vertical-separator'></Box>
              <Box className='centered-column-wrapper'>
              <Can permission={PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_DELETE}>
                  <DsasButton label='Supprimer' icon={faTrashCan} onClick={() => { dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer la compétition ?", () => {
                    dispatch(deleteCompetition(competition._id, (id) => {removeCompetitionFromList(id) ; addNotification({
                      title : "Suppression", 
                      type : "success", 
                      description : "La competition "+ competition.name+" a été supprimée."
                    })}))
                  })) }} variant = 'secondary' />
              </Can>
              </Box>

            </Box>

    </Card>
  );
};

export default CompetitionCard;
